import { createAction, props } from '@ngrx/store';

export const LoadDowntimeMessage = createAction('[Downtime] Load Downtime Message');

export const LoadDowntimeMessageSuccess = createAction(
  '[Downtime] Load Downtime Message Success',
  props<{ downtimeMessage: string }>()
);

export const LoadDowntimeMessageFail = createAction(
  '[Downtime] Load Downtime Message Fail',
  props<{ error: Error }>()
);
